<template>
  <div>
    <v-row class="ma-auto">
      <div class="pb-2 pt-4 ma-auto">
        <span class="font-weight-medium text-h5">Highlights</span>
      </div>
      <v-col>
        <div class="flex justify-end">
          <v-row align="center" align-content="end" justify="end" class="pt-2">
            <div style="color: #516077" class="pt-1"> Reporting period: {{ this.displayDates() }}
            </div>
            &nbsp |
            <v-btn @click="handleDownloadReport" elevation="0" color="white">
              <v-icon>mdi-download</v-icon>
              Download report
            </v-btn>
          </v-row>
        </div>
      </v-col>
    </v-row>
    <div id="pdfContent">
      <v-row>
        <v-col cols="12" md="4">
          <MetricCard
              title="Total Attendees Joined"
              :value="currentEvent.analyticsData.allAtteneesCount"
              image="account-grey.svg"
              tooltip-text="Total number of attendees who have joined the event."
          />
        </v-col>
        <v-col cols="12" md="4">
          <MetricCard
              title="Total Connections Made"
              :value="currentEvent.noOfConnections"
              image="account-group.svg"
          />
        </v-col>
        <v-col cols="12" md="4">
          <MetricCard
              title="Total Partner Profile Views"
              :value="currentEvent.analyticsData.totalPartnersProfileViews"
              image="cursor-click.svg"
          />
        </v-col>
        <!--        <v-col cols="12" md="3">
                  <MetricCard
                    title="Total Event Promotion"
                    :value="totalEventPromotionShares"
                    image="share.svg"
                  />
                </v-col>-->

        <v-col cols="12" md="4">
          <MetricCard
              title="Match-making"
              :value="currentEvent.analyticsData.totalMatchMaking"
              image="account-switch.svg"
              tooltip-text="Total number of attendees that completed their preferences to produce their list of Suggested Connections."
          />
        </v-col>
        <v-col cols="12" md="4">
          <MetricCard
              title="Total Messages Sent"
              :value="currentEvent.analyticsData.totalMessagesSent"
              image="messages.svg"
          />
        </v-col>
        <v-col cols="12" md="4">
          <MetricCard
              title="Total Posts Created"
              :value="currentEvent.analyticsData.totalPostCreated"
              image="total_posts.svg"
              tooltip-text="Total number of posts created within the event newsfeed."
          />
        </v-col>
      </v-row>
      <div class="pb-2 pt-4">
        <span class="font-weight-medium text-h5 ">All analytics</span>
      </div>
      <v-row align="stretch">
        <v-col cols="12" md="6">
          <SubEventAnalytics/>
        </v-col>
        <v-col cols="12" md="6">
          <AttendeeAnalytics/>
        </v-col>
        <v-col cols="12" md="6">
          <AttendeeEventPreferences/>
        </v-col>
        <v-col cols="12" md="6">
          <MessagingAnalytics/>
        </v-col>
        <v-col cols="12" md="6">
          <PartnersAnalytics/>
        </v-col>
        <v-col cols="12" md="6">
          <ConnectionsAnalytics @view="showConnections"/>
        </v-col>
        <v-col cols="12" md="6" class="mb-2">
          <PostAnalytics/>
        </v-col>
        <v-col cols="12" md="6" class="mb-2">
          <NotesAnalytics class="pb-5"/>
          <MeetingsAnalytics/>
        </v-col>
      </v-row>

    </div>
    <div v-if="showPdf">
      <v-card height="2000"></v-card>
    </div>
    <AnalyticsData id="pdfData" v-if="showPdf"/>
    <div id="canvasPreview"></div>
    <v-dialog v-model="showConnectionsDialog" width="800">
      <ConnectionsAnalyticsDialog/>
    </v-dialog>
  </div>

</template>


<script>
import MetricCard from "@/components/SuperUser/MetricCard";
import SponsorAnalytics from "./SponsorAnalytics";
import PromotionAnalytics from "./PromotionAnalytics";
import SubEventAnalytics from "./SubEventAnalytics";
import BarChart from "./BarChart";
import {mapActions, mapGetters} from "vuex";
import jsPDF from "jspdf";
import AttendeeAnalytics from "@/components/MultiConnect/Analytics/AttendeeAnalytics.vue";
import AttendeeEventPreferences from "@/components/MultiConnect/Analytics/AttendeeEventPreferences.vue";
import ConnectionsAnalytics from "@/components/MultiConnect/Analytics/ConnectionsAnalytics.vue";
import MessagingAnalytics from "@/components/MultiConnect/Analytics/MessagingAnalytics.vue";
import PartnersAnalytics from "@/components/MultiConnect/Analytics/PartnersAnalytics.vue";
import PostAnalytics from "@/components/MultiConnect/Analytics/PostAnalytics.vue";
import NotesAnalytics from "@/components/MultiConnect/Analytics/NotesAnalytics.vue";
import MeetingsAnalytics from "@/components/MultiConnect/Analytics/MeetingsAnalytics.vue";
import Loading from "@/components/Loading.vue";
import AnalyticsData from "@/components/MultiConnect/Analytics/AnalyticsData.vue";
import html2canvas from "html2canvas";
import ConnectionsAnalyticsDialog
  from "@/components/MultiConnect/Analytics/AnalyticsDialog/ConnectionsAnalyticsDetails.vue";
import {getDocById, getPostDoc, getQueryByCollectionName} from "@/shared/firebase_utils";
import {where} from "firebase/firestore";


export default {
  components: {
    ConnectionsAnalyticsDialog,
    AnalyticsData,
    Loading,
    MeetingsAnalytics,
    NotesAnalytics,
    PostAnalytics,
    PartnersAnalytics,
    MessagingAnalytics,
    ConnectionsAnalytics,
    AttendeeEventPreferences,
    AttendeeAnalytics,
    MetricCard,
    SponsorAnalytics,
    PromotionAnalytics,
    SubEventAnalytics,
    BarChart,
  },
  async created() {
    this.messageData = [
      this.currentEvent.noOfMessagesSentPreEvent,
      this.currentEvent.noOfMessagesSentDuringEvent,
      this.noOfMessagesSentPostEvent
    ];

    this.chartData.datasets[0].data = this.messageData;

    //this.initNewsfeedPostChartData();

    let promotionalPostDocRef = await getPostDoc(this.currentEvent.postId);

    if (promotionalPostDocRef.exists) {
      this.promotionalPost = promotionalPostDocRef.data();
    }
  },
  data() {
    return {
      showPdf: false,
      showConnectionsDialog: false,
      messages: [],

      // unsubscribeEventsSnapshot: null,
      // unsubscribeChatSnapshot: null,
      chartData: {
        labels: ["Pre", "During", "Post"],
        datasets: [
          {
            data: [],
            backgroundColor: ["rgb(0,36,52)", "rgb(0,36,52)", "rgb(0,36,52)"],
            barThickness: 50,
          },
        ],
      },
      chartOptions: {
        responsive: true,
        layout: {padding: 20},
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                stepSize: 50,
              },
              min: 0,
              max: 200,
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
              ticks: {},
            },
          ],
        },
      },
      messageData: [],
      promotionalPost: {},
      noOfMessagesSentPostEvent: 0,
    };
  },
  computed: {
    ...mapGetters([
      "currentEvent",
      "registrants",
      "linkedSessions",
      "linkedSubEvents",
    ]),
    noOfPostComments() {
      return this.promotionalPost.noOfComments || "-";
    },
    noOfMatchMaking() {
      if (this.eventAttendees === null || this.eventAttendees === undefined) return 0;
      const attendeesWithMatchMaking = this.eventAttendees.filter((item) => item.preferredCategories && Object.keys(item.preferredCategories).length > 0);
      return attendeesWithMatchMaking.length;
    },
    noOfPostReactions() {
      let noOfPostReactions = 0;

      if (this.promotionalPost.noOfLikes)
        noOfPostReactions += this.promotionalPost.noOfLikes;
      if (this.promotionalPost.noOfLoves)
        noOfPostReactions += this.promotionalPost.noOfLoves;
      if (this.promotionalPost.noOfPraises)
        noOfPostReactions += this.promotionalPost.noOfPraises;

      return noOfPostReactions;
    },
    totalSponsorClicks() {
      let count = 0;
      this.currentEvent.sponsorsAnalytics.forEach((sponsorAnalytic) => {
        sponsorAnalytic.clickData.forEach((item) => {
          count += item.clickCount;
        });
      });

      return count;
    },
    totalSponsors() {
      let currentEventSponsors = this.currentEvent.sponsors.length;
      let subEventSponsor = 0;
      this.linkedSubEvents.forEach((subEvent) => {
        subEventSponsor += subEvent.sponsors.length;
      });
      return subEventSponsor + currentEventSponsors;
    },
    totalClicks() {
      let totalClicks = 0;
      this.currentEvent.sponsorsAnalytics.forEach((sponsorAnalytic) => {
        totalClicks += this.getClickCount(sponsorAnalytic);
      });
      return totalClicks;
    },
    sponsorAnalytics() {
      let arr = [...this.currentEvent.sponsorsAnalytics];
      this.linkedSubEvents.forEach((subEvent) => {
        if (subEvent.sponsorsAnalytics.length > 0)
          arr.push(...subEvent.sponsorsAnalytics);
      });
      return arr;
    },
    preEventPromotionAnalyticData() {
      if (this.currentEvent.socialMediaPlatform == "Facebook") {
        return this.currentEvent.facebookPreEventPromotionAnalyticData;
      } else if (this.currentEvent.socialMediaPlatform == "Instagram") {
        return this.currentEvent.instagramPreEventPromotionAnalyticData;
      } else {
        return this.currentEvent.linkedinPreEventPromotionAnalyticData;
      }
    },
    postEventPromotionAnalyticData() {
      if (this.currentEvent.socialMediaPlatform == "Facebook") {
        return this.currentEvent.facebookPostEventPromotionAnalyticData;
      } else if (this.currentEvent.socialMediaPlatform == "Instagram") {
        return this.currentEvent.instagramPostEventPromotionAnalyticData;
      } else {
        return this.currentEvent.linkedinPostEventPromotionAnalyticData;
      }
    },
    totalEventPromotionShares() {
      let count = 0;
      this.preEventPromotionAnalyticData.forEach((item) => {
        count += item.shareCount;
      });

      this.postEventPromotionAnalyticData.forEach((item) => {
        count += item.shareCount;
      });
      return count;
    },
    noOfChatroomsEnabled() {
      let noOfEnabledChatrooms = 0;
      if (this.currentEvent.enableChatroom) noOfEnabledChatrooms++;
      this.linkedSubEvents.forEach((subEvent) => {
        if (subEvent.enableChatroom) noOfEnabledChatrooms++;
      });
      this.linkedSessions.forEach((session) => {
        if (session.enableChatroom) noOfEnabledChatrooms++;
      });

      return noOfEnabledChatrooms;
    },
    postsChartData() {
      return {
        labels: ["Pre", "During", "Post"],
        datasets: [
          {
            data: [
              this.noOfPostsSharedPreEvent,
              this.noOfPostsSharedDuringEvent,
              this.noOfPostsSharedAfterEventEnded
            ],
            backgroundColor: ["rgb(0,36,52)", "rgb(0,36,52)", "rgb(0,36,52)"],
            barThickness: 50,
          },
        ],
      };
    },
    messageChartData() {
      return {
        labels: ["Pre", "During", "Post"],
        datasets: [
          {
            data: [
              this.currentEvent.noOfMessagesSentPreEvent,
              this.currentEvent.noOfMessagesSentDuringEvent,
              this.noOfMessagesSentPostEvent
            ],
            backgroundColor: ["rgb(0,36,52)", "rgb(0,36,52)", "rgb(0,36,52)"],
            barThickness: 50,
          },
        ],
      };
    },

    totalPostsInNewsfeed() {
      return this.noOfPostsSharedPreEvent + this.noOfPostsSharedDuringEvent + this.noOfPostsSharedAfterEventEnded;
    },
    totalPreEventShareCount() {
      let count = 0;
      this.preEventPromotionAnalyticData.forEach((item) => {
        count += item.shareCount;
      });
      return count;
    },
    totalPostEventShareCount() {
      let count = 0;
      this.postEventPromotionAnalyticData.forEach((item) => {
        count += item.shareCount;
      });
      return count;
    },
  },
  methods: {
    ...mapActions(["setCurrentEvent", "showSnackbar", "hideSnackbar"]),
    async init() {
      /*   await Promise.all(
             [
               this.fetchEventAttendees(this.currentEvent),
               this.fetchEventConnections(this.currentEvent.id),
               this.initializePartners(this.currentEvent.id),
               this.fetchPostCount(this.currentEvent.id),
               this.initializeMeetings(this.currentEvent.id),
               this.initializeNotes(this.currentEvent.id)
             ]
         );*/
    },
    showConnections() {
      this.showConnectionsDialog = true;
    },
    async getNoOfChatroomsUsed() {
      let noOfChatRoomsUsed = 0;
      let eventChatRoomRef = await getDocById("chat_rooms", this.currentEvent.id);
      if (eventChatRoomRef.exists) noOfChatRoomsUsed++;

      await Promise.all(
          this.linkedSubEvents.map(async (subEvent) => {
            let subEventChatRoomRef = await getDocById("chat_rooms", subEvent.id);
            if (subEventChatRoomRef.exists) noOfChatRoomsUsed++;
          })
      );

      await Promise.all(
          this.linkedSessions.map(async (session) => {
            let sessionChatRoomRef = await getDocById("chat_rooms", session.id);
            if (sessionChatRoomRef.exists) noOfChatRoomsUsed++;
          })
      );


    },
    getClickCount(sponsorAnalytic) {
      let count = 0;
      sponsorAnalytic.clickData.forEach((item) => {
        count += item.clickCount;
      });
      return count;
    },
    getNoOfSessions(subEvent) {
      if (subEvent.linkedSessions.length == 0) return "-";
      else
        return subEvent.linkedSessions.length > 1
            ? subEvent.linkedSessions.length + " sessions"
            : subEvent.linkedSessions.length + " session";
    },
    getNoOfSpeakers(subEvent) {
      let speakers = this.currentEvent.speakers.filter(
          (speaker) => {
            return (
                speaker.associatedSpeakerSessions.length > 0 &&
                speaker.associatedSpeakerSessions.some(sessionId => subEvent.linkedSessions.includes(sessionId)))
          }
      );
      return speakers.length;
    },
    getNoOfRegistrants(subEvent) {
      if (this.eventAttendees === null || this.eventAttendees === undefined) return "-";
      let registrants = this.eventAttendees.filter(attendee => attendee.businessCardId != "");
      if (registrants && registrants.length > 0) return registrants.length;
      else return "-";
    },
    async getNoOfMessagesSent() {
      let messages = 0;


      let eventChatRoomRef = await getQueryByCollectionName("messages", where("chatRoomId", "==", this.currentEvent.id));
      if (eventChatRoomRef.size > 0) messages += eventChatRoomRef.size;

      await Promise.all(
          this.linkedSubEvents.map(async (subEvent) => {
            let subEventChatRoomRef = await getQueryByCollectionName("messages", where("chatRoomId", "==", subEvent.id));
            if (subEventChatRoomRef.size > 0)
              messages += subEventChatRoomRef.size;
          })
      );

      await Promise.all(
          this.linkedSessions.map(async (session) => {
            let sessionChatRoomRef = await getQueryByCollectionName("messages", where("chatRoomId", "==", session.id));
            if (sessionChatRoomRef.size > 0) messages += sessionChatRoomRef.size;
          })
      );
    },
    downloadReport() {
      const element = document.getElementById('pdfData');
      console.log(element);
      const date = new Date();
      const formattedDate = new Intl.DateTimeFormat('en-AU', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).format(date);
      html2canvas(element).then(canvas => {
        const pdf = new jsPDF();
        const width = pdf.internal.pageSize.getWidth();
        const ratio = width/canvas.width;
        const height = ratio * canvas.height;
        pdf.internal.pageSize.height = height;
        const canvasData = canvas.toDataURL('image/jpeg', 1.0);
        pdf.addImage(canvasData, 'JPEG', 0, 0, width, height);
        pdf.save(`${this.currentEvent.name} analytics ${formattedDate}.pdf`);
        this.showSnackbar({text: "Report Downloaded", show: true})
      });
    },
    formatDate(date) {
      const options = {day: 'numeric', month: 'short', year: 'numeric'};
      return date.toLocaleDateString('en-US', options);
    },
    displayDates() {

      const startDateTime = this.currentEvent.name.toLowerCase().includes('evoke') ? new Date("2024-2-7") : this.currentEvent.getEventActivationDateTime();
      const endDateTime = new Date(this.currentEvent.endDateTime);
      const startDateMinus14Days = new Date(startDateTime.getTime());
      startDateMinus14Days.setDate(startDateMinus14Days.getDate() - 14);
      const endDatePlus14Days = new Date(endDateTime.getTime());
      endDatePlus14Days.setDate(endDatePlus14Days.getDate() + 14);
      const startFormatted = this.formatDate(startDateMinus14Days);
      const endFormatted = this.formatDate(endDatePlus14Days);

      const startYear = startDateMinus14Days.getFullYear();
      const endYear = endDatePlus14Days.getFullYear();
      let date = '';
      if (startYear === endYear) {
        date = `${startFormatted.slice(0, -6)} - ${endFormatted}`;
      } else {
        date = `${startFormatted} - ${endFormatted}`;
      }
      return date;
    },
    handleDownloadReport() {
      this.showSnackbar({text: "Downloading report...", show: true});
      this.showPdf = true;
      setTimeout(() => {
        this.downloadReport();
        setTimeout(() => {
          this.showPdf = false;
        }, 100);
      }, 500);


    },
    async getNoOfMessagesSentPreEvent() {
      let messages = 0;


      let eventChatRoomRef = await getQueryByCollectionName("messages",
          where("chatRoomId", "==", this.currentEvent.id),
          where("createdOn", "<", this.currentEvent.startDateTime));

      if (eventChatRoomRef.size > 0) messages += eventChatRoomRef.size;

      await Promise.all(
          this.linkedSubEvents.map(async (subEvent) => {
            let subEventChatRoomRef = await getQueryByCollectionName("messages",
                    where("chatRoomId", "==", subEvent.id),
                    where("createdOn", "<", this.currentEvent.startDateTime));
            if (subEventChatRoomRef.size > 0)
              messages += subEventChatRoomRef.size;
          })
      );

      await Promise.all(
          this.linkedSessions.map(async (session) => {
            let sessionChatRoomRef = await getQueryByCollectionName("messages",
                    where("chatRoomId", "==", session.id),
                    where("createdOn", "<", this.currentEvent.startDateTime));
            if (sessionChatRoomRef.size > 0) messages += sessionChatRoomRef.size;
          })
      );


    },
    /*    async getNoOfMessagesSentDuringEvent() {
          let messages = 0;

          let db = firebase.firestore();
          let eventChatRoomRef = await db
            .collection("messages")
            .where("chatRoomId", "==", this.currentEvent.id)
            .where("createdOn", ">=", this.currentEvent.startDateTime)
            .get();

          if (eventChatRoomRef.size > 0) messages += eventChatRoomRef.size;

          await Promise.all(
            this.linkedSubEvents.map(async (subEvent) => {
              let subEventChatRoomRef = await db
                .collection("messages")
                .where("chatRoomId", "==", subEvent.id)
                .where("createdOn", ">=", this.currentEvent.startDateTime)
                .get();
              if (subEventChatRoomRef.size > 0)
                messages += subEventChatRoomRef.size;
            })
          );

          await Promise.all(
            this.linkedSessions.map(async (session) => {
              let sessionChatRoomRef = await db
                .collection("messages")
                .where("chatRoomId", "==", session.id)
                .where("createdOn", ">=", this.currentEvent.startDateTime)
                .get();

              if (sessionChatRoomRef.size > 0) messages += sessionChatRoomRef.size;
            })
          );


        }*/
    /*    async getNoOfMessagesSentAfterEvent() {
          let messages = 0;

          let db = firebase.firestore();
          let eventChatRoomRef = await db
            .collection("messages")
            .where("chatRoomId", "==", this.currentEvent.id)
            .where("createdOn", ">=", this.currentEvent.endDateTime)
            .get();

          if (eventChatRoomRef.size > 0) messages += eventChatRoomRef.size;

          await Promise.all(
            this.linkedSubEvents.map(async (subEvent) => {
              let subEventChatRoomRef = await db
                .collection("messages")
                .where("chatRoomId", "==", subEvent.id)
                .where("createdOn", ">=", this.currentEvent.endDateTime)
                .get();
              if (subEventChatRoomRef.size > 0)
                messages += subEventChatRoomRef.size;
            })
          );

          await Promise.all(
            this.linkedSessions.map(async (session) => {
              let sessionChatRoomRef = await db
                .collection("messages")
                .where("chatRoomId", "==", session.id)
                .where("createdOn", ">=", this.currentEvent.endDateTime)
                .get();

              if (sessionChatRoomRef.size > 0) messages += sessionChatRoomRef.size;
            })
          );


          this.noOfMessagesSentPostEvent = messages;
        }*/
    /*    async getNoOfPostsSharedPreEventStart() {
          let count = 0;
          let db = firebase.firestore();
          await Promise.all(
            this.currentEvent.attendees.map(async (attendee) => {
              let docRef = await db
                .collection("posts")
                .where("businessCardId", "==", attendee.businessCardId)
                .where("createdOn", "<", this.currentEvent.startDateTime)
                .where("createdOn", ">=", attendee.joinedDate)
                .get();
              if (docRef.size > 0) count += docRef.size;
            })
          );
          this.noOfPostsSharedPreEvent = count;

        },*/
    /*    async getNoOfPostsSharedDuringEvent() {
          let count = 0;
          let db = firebase.firestore();
          await Promise.all(
            this.currentEvent.attendees.map(async (attendee) => {
              let docRef = await db
                .collection("posts")
                .where("businessCardId", "==", attendee.businessCardId)
                .where("createdOn", ">=", this.currentEvent.startDateTime)
                .where("createdOn", "<=", this.currentEvent.endsDateTime)
                .where("createdOn", ">=", attendee.joinedDate)
                .get();
              if (docRef.size > 0) count += docRef.size;
            })
          );

          this.noOfPostsSharedDuringEvent = count;
        },*/
    /*    async getNoOfPostsSharedAfterEventEnds() {
          let count = 0;
          let db = firebase.firestore();
          await Promise.all(
            this.currentEvent.attendees.map(async (attendee) => {
              let docRef = await db
                .collection("posts")
                .where("businessCardId", "==", attendee.businessCardId)
                .where("createdOn", ">=", this.currentEvent.endDateTime)
                .where("createdOn", ">=", attendee.joinedDate)
                .get();
              if (docRef.size > 0) count += docRef.size;
            })
          );

          this.noOfPostsSharedAfterEventEnded = count;
        },*/
    /*    initNewsfeedPostChartData() {
          this.getNoOfPostsSharedPreEventStart();
          this.getNoOfPostsSharedAfterEventEnds();
          this.getNoOfPostsSharedDuringEvent();
          this.postsChartData.datasets[0].data = [
            this.noOfPostsSharedPreEvent,
            this.noOfPostsSharedDuringEvent,
            this.noOfPostsSharedAfterEventEnded,
          ];
        },*/
  },
};
</script>

<style scoped>

</style>